import { render, staticRenderFns } from "./TargetSetting.vue?vue&type=template&id=1a2a5805&scoped=true"
import script from "./TargetSetting.vue?vue&type=script&lang=js"
export * from "./TargetSetting.vue?vue&type=script&lang=js"
import style0 from "./TargetSetting.vue?vue&type=style&index=0&id=1a2a5805&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a5805",
  null
  
)

export default component.exports